import { getUsersBrowserData } from '~/utils/helpers'

interface ChangeEntry {
  year: number
  avgMilkAmount: number
  yearlyConcentratedFeedAmountPerCow: number
}

export interface ClimaRegistrationData {
  cowsNumber?: number
  avgMilkAmount?: number
  yearlyConcentratedFeedAmountPerCow?: number
  changesInLastThreeYears?: number
  changes?: ChangeEntry[]
  farmerId: string
  selfCalculatedFeedingPlan?: number
  consultantLastName?: string
  consultantFirstName?: string
  consultantPhoneNumber?: string
  consultantEmail?: string
  consultantCompanyName?: string
  feedingPlanFile?: {
    data: string
    name: string
  }
}

export function createRegistrationFormData(data: ClimaRegistrationData): FormData {
  const formData = new FormData()
  const browserData = getUsersBrowserData()

  Object.keys(browserData).forEach((key) => {
    formData.append(key, browserData[key as keyof typeof browserData])
  })

  formData.append('cowsNumber', data.cowsNumber?.toString() || '')
  formData.append('farmerId', data.farmerId?.toString() || '')
  formData.append('avgMilkAmount', data.avgMilkAmount?.toString() || '')
  formData.append('yearlyConcentratedFeedAmountPerCow', data.yearlyConcentratedFeedAmountPerCow?.toString() || '')
  formData.append('changesInLastThreeYears', data.changesInLastThreeYears?.toString() || '')
  formData.append('selfCalculatedFeedingPlan', data.selfCalculatedFeedingPlan?.toString() || '')

  if (data.changesInLastThreeYears === 1 && data.changes) {
    data.changes.forEach((item, index) => {
      Object.entries(item).forEach(([key, value]) => {
        formData.append(`changes[${index}][${key}]`, value);
      });
    });
  }

  if (data.selfCalculatedFeedingPlan === 0) {
    formData.append('consultantLastName', data.consultantLastName || '')
    formData.append('consultantFirstName', data.consultantFirstName || '')
    formData.append('consultantPhoneNumber', data.consultantPhoneNumber || '')
    formData.append('consultantEmail', data.consultantEmail || '')
    formData.append('consultantCompanyName', data.consultantCompanyName || '')
  }

  if (data.feedingPlanFile?.data) {
    const mimeType = data.feedingPlanFile.data.split(';')[0].split('data:')[1]
    const base64Data = data.feedingPlanFile.data.split(',')[1]
    const byteCharacters = atob(base64Data)
    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)
    const blob = new Blob([byteArray], { type: mimeType })
    formData.append('feedingPlanFile', blob, data.feedingPlanFile.name)
  }
  return formData
}

export const getFileIcon = (fileName?: string): string => {
  if (!fileName) return 'file alternate outline'
  const ext = fileName.split('.').pop()?.toLowerCase()
  switch (ext) {
    case 'pdf':
      return 'file pdf outline'
    case 'xlsx':
    case 'xls':
      return 'file excel outline'
    case 'jpg':
    case 'gif':
    case 'jpeg':
    case 'png':
    case 'bmp':
      return 'file image outline'
    default:
      return 'file alternate outline'
  }
}

export const getFileTypeLabel = (fileName?: string): string => {
  if (!fileName) return 'Document'
  const ext = fileName.split('.').pop()?.toLowerCase()
  switch (ext) {
    case 'pdf':
      return 'PDF'
    case 'xlsx':
    case 'xls':
      return 'Excel'
    case 'gif':
      return 'GIF'
    case 'jpg':
    case 'jpeg':
      return 'JPEG'
    case 'png':
      return 'PNG'
    case 'bmp':
      return 'BMP'
    default:
      return 'Document'
  }
}
